/** Internal type. DO NOT USE DIRECTLY. */
import { gql } from "@apollo/client"
import * as Apollo from "@apollo/client"

import * as Types from "../../../shared/types/__generated__/graphql"
import { TeamMemberFragmentDoc } from "../../team-members/graphql/fragments.generated"

type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] }
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never
    }

const defaultOptions = {} as const
export type AcceptTeamInvitationInput = {
  id: string
  invitationAccepted: boolean
}

export type SendTeamInvitationMutationVariables = Exact<{
  teamID: string
  teamMemberID: string
}>

export type SendTeamInvitationMutation = {
  __typename: "Mutation"
  teamMember: {
    __typename: "TeamMember"
    id: string
    role: string
    invitedAt?: string | null
    invitationAcceptedAt?: string | null
    invitationAccepted: boolean
    createdAt: string
    updatedAt: string
    user?: {
      __typename: "User"
      id: string
      name?: string | null
      email: string
      createdAt: string
      updatedAt: string
    } | null
  }
}

export type AcceptTeamInvitationMutationVariables = Exact<{
  teamID: string
  teamMemberID: string
  input: Types.AcceptTeamInvitationInput
}>

export type AcceptTeamInvitationMutation = {
  __typename: "Mutation"
  acceptTeamInvitation: {
    __typename: "TeamMember"
    id: string
    role: string
    invitedAt?: string | null
    invitationAcceptedAt?: string | null
    invitationAccepted: boolean
    createdAt: string
    updatedAt: string
    user?: {
      __typename: "User"
      id: string
      name?: string | null
      email: string
      createdAt: string
      updatedAt: string
    } | null
  }
}

export type DeclineTeamInvitationMutationVariables = Exact<{
  teamID: string
  teamMemberID: string
}>

export type DeclineTeamInvitationMutation = {
  __typename: "Mutation"
  declineTeamInvitation: { __typename: "DeleteResponse"; success: boolean }
}

export const SendTeamInvitationDocument = gql`
  mutation SendTeamInvitation($teamID: ID!, $teamMemberID: ID!) {
    teamMember: sendTeamInvitation(
      teamID: $teamID
      teamMemberID: $teamMemberID
    )
      @rest(
        type: "TeamMember"
        method: "POST"
        path: "/project-list/teams/{args.teamId}/members/{args.teamMemberID}/invitation/send"
        bodySerializer: "teamMember"
      ) {
      ...TeamMember
    }
  }
  ${TeamMemberFragmentDoc}
`
export type SendTeamInvitationMutationFn = Apollo.MutationFunction<
  SendTeamInvitationMutation,
  SendTeamInvitationMutationVariables
>

/**
 * __useSendTeamInvitationMutation__
 *
 * To run a mutation, you first call `useSendTeamInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendTeamInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendTeamInvitationMutation, { data, loading, error }] = useSendTeamInvitationMutation({
 *   variables: {
 *      teamID: // value for 'teamID'
 *      teamMemberID: // value for 'teamMemberID'
 *   },
 * });
 */
export function useSendTeamInvitationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SendTeamInvitationMutation,
    SendTeamInvitationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    SendTeamInvitationMutation,
    SendTeamInvitationMutationVariables
  >(SendTeamInvitationDocument, options)
}
export type SendTeamInvitationMutationHookResult = ReturnType<
  typeof useSendTeamInvitationMutation
>
export type SendTeamInvitationMutationResult =
  Apollo.MutationResult<SendTeamInvitationMutation>
export type SendTeamInvitationMutationOptions = Apollo.BaseMutationOptions<
  SendTeamInvitationMutation,
  SendTeamInvitationMutationVariables
>
export const AcceptTeamInvitationDocument = gql`
  mutation AcceptTeamInvitation(
    $teamID: ID!
    $teamMemberID: ID!
    $input: AcceptTeamInvitationInput!
  ) {
    acceptTeamInvitation(
      teamID: $teamID
      teamMemberID: $teamMemberID
      input: $input
    )
      @rest(
        type: "TeamMember"
        method: "PUT"
        path: "/project-list/teams/{args.teamID}/members/{args.teamMemberID}/invitation/accept"
        bodySerializer: "teamInvitation"
      ) {
      ...TeamMember
    }
  }
  ${TeamMemberFragmentDoc}
`
export type AcceptTeamInvitationMutationFn = Apollo.MutationFunction<
  AcceptTeamInvitationMutation,
  AcceptTeamInvitationMutationVariables
>

/**
 * __useAcceptTeamInvitationMutation__
 *
 * To run a mutation, you first call `useAcceptTeamInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptTeamInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptTeamInvitationMutation, { data, loading, error }] = useAcceptTeamInvitationMutation({
 *   variables: {
 *      teamID: // value for 'teamID'
 *      teamMemberID: // value for 'teamMemberID'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAcceptTeamInvitationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AcceptTeamInvitationMutation,
    AcceptTeamInvitationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    AcceptTeamInvitationMutation,
    AcceptTeamInvitationMutationVariables
  >(AcceptTeamInvitationDocument, options)
}
export type AcceptTeamInvitationMutationHookResult = ReturnType<
  typeof useAcceptTeamInvitationMutation
>
export type AcceptTeamInvitationMutationResult =
  Apollo.MutationResult<AcceptTeamInvitationMutation>
export type AcceptTeamInvitationMutationOptions = Apollo.BaseMutationOptions<
  AcceptTeamInvitationMutation,
  AcceptTeamInvitationMutationVariables
>
export const DeclineTeamInvitationDocument = gql`
  mutation DeclineTeamInvitation($teamID: ID!, $teamMemberID: ID!) {
    declineTeamInvitation(teamID: $teamID, teamMemberID: $teamMemberID)
      @rest(
        endpoint: "delete"
        type: "DeleteResponse"
        method: "DELETE"
        path: "/project-list/teams/{args.teamID}/members/{args.teamMemberID}/invitation/decline"
      ) {
      success
    }
  }
`
export type DeclineTeamInvitationMutationFn = Apollo.MutationFunction<
  DeclineTeamInvitationMutation,
  DeclineTeamInvitationMutationVariables
>

/**
 * __useDeclineTeamInvitationMutation__
 *
 * To run a mutation, you first call `useDeclineTeamInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeclineTeamInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [declineTeamInvitationMutation, { data, loading, error }] = useDeclineTeamInvitationMutation({
 *   variables: {
 *      teamID: // value for 'teamID'
 *      teamMemberID: // value for 'teamMemberID'
 *   },
 * });
 */
export function useDeclineTeamInvitationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeclineTeamInvitationMutation,
    DeclineTeamInvitationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    DeclineTeamInvitationMutation,
    DeclineTeamInvitationMutationVariables
  >(DeclineTeamInvitationDocument, options)
}
export type DeclineTeamInvitationMutationHookResult = ReturnType<
  typeof useDeclineTeamInvitationMutation
>
export type DeclineTeamInvitationMutationResult =
  Apollo.MutationResult<DeclineTeamInvitationMutation>
export type DeclineTeamInvitationMutationOptions = Apollo.BaseMutationOptions<
  DeclineTeamInvitationMutation,
  DeclineTeamInvitationMutationVariables
>
